import {
  FutureBookingsConfirmOutcome,
  IPassengerDto,
  IPassengerStationsChange,
  IShiftStationOptionsChange,
} from "@ryde/shared";

/** Maps an outcome to the flag value to send, or `undefined` to omit the flag entirely. */
export const resolveShouldUpdateFutureBookingsStations = (
  outcome: FutureBookingsConfirmOutcome,
): boolean | undefined => {
  switch (outcome) {
    case FutureBookingsConfirmOutcome.Approved:
      return true;
    case FutureBookingsConfirmOutcome.Declined:
    case FutureBookingsConfirmOutcome.NoImpact:
      return false;
    default:
      return undefined;
  }
};

/**
 * Narrows the passenger form values down to the six station fields the impact preview asks about,
 * so the rest of the edited passenger never reaches the read-only preview endpoint.
 */
export const buildPassengerStationsChange = (
  formData: Partial<IPassengerDto>,
): IPassengerStationsChange => ({
  sourceStation1Id: formData.sourceStation1Id,
  sourceStation2Id: formData.sourceStation2Id,
  destinationStation1Id: formData.destinationStation1Id,
  destinationStation2Id: formData.destinationStation2Id,
  metadata: {
    sourceStation3Id: formData.metadata?.sourceStation3Id,
    destinationStation3Id: formData.metadata?.destinationStation3Id,
  },
});

/** Same narrowing for a shift: only the two station-option fields drive the preview. */
export const buildShiftStationOptionsChange = (
  formData: IShiftStationOptionsChange,
): IShiftStationOptionsChange => ({
  metadata: {
    stationOption: formData.metadata?.stationOption,
    stationOptionB: formData.metadata?.stationOptionB,
  },
});
